/**
 * @title: 一联面单模板
 * @author: lorry
 * @time: 2020-01-08
 */
const img = [
  { href: require('@/assets/images/shou.png') },
  { href: require('@/assets/images/ji.png') },
  { href: require('@/assets/images/gongzhonghao.png') },
  { href: require('@/assets/images/bao.png') },
]
export function oneLinkPage(options, index, length, dayObj, $lang) {
  return `
    <!DOCTYPE html> 
  <html lang="en">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="ie=edge">
    <title>${$lang('电子面单一联单')}</title>
    <style>
    html{
      font-family: "黑体";
    }
  
  #demoContainer { 
    width: 290px;
    background: #fff;
    float: left;
    margin-right: 40px;
  }
  
  .pdfDom {
    width: 290px;
    /* height: 504px; */
    margin-right: 30px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
  }
  .pdfDom .top-bar {
    height: 52px;
    border-bottom: 1px dashed #000;
    position: relative;
  }
  .pdfDom .top-bar .top-bar-right{
    display: ${options.codNeed === 1 ? 'block' : 'none'};
    height:28px;
    line-height:25px;
    letter-spacing:2px;
    width: 76px;
    padding:2px 5px;
    position:absolute;
    right:23px;
    top:7px;
    text-align:center;
    background: #000;
    font-size: 16px;
    color:#fff;
    font-weight:bold;
  }
  .top-bar-right1{
    display: ${options.totalFreight && options.codNeed !== 1 ? 'block' : 'none'};
    letter-spacing: 4px;
    font-size: 16px;
    color:#fff;
    font-weight:bold;
    position:absolute;
    right:34px;
    background: #000;
    top:12px;
    text-align:center;
    height:22px;
    width: 50px;
    padding:4px 6px 0;
  }
  .top-bar-right2{
      display: ${options.signReceipt === 1 ? 'block' : 'none'};
      height:28px;
      line-height:25px;
      letter-spacing:2px;
      width: 76px;
      padding:2px 5px;
      position:absolute;
      right:23px;
      top:7px;
      text-align:center;
      background: #000;
      font-size: 16px;
      color:#fff;
      font-weight:bold;
  }
  .pdfDom .top-bar #barcode {
    position: absolute;
    top: 10px;
    right: 40px;
  }
  .pdfDom .bottom-bar {
      width:223px;
    height: 18mm;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px dashed #000;
  }
  .pdfDom .qr-type {
    height: 38px;
    border-top: 1px dashed #000;
    border-bottom: 1px dashed #000;;
    overflow:hidden;
  }
  .pdfDom .qr-type  .type-code{
    float:left;
    font-size:30px;
    font-weight:bold;
    width:240px;
    text-align:center;
    line-height:38px;
  }
  .pdfDom .qr-type .type-name {
    width: 49px;
    height:38px;
    /* line-height:30px; */
    border-left: 1px dashed #000;
    font-size: 13px;
    text-align: center;
  }
  .type-namei{
    padding: 4px 8px 0;
    font-weight:bold
  }
  .pdfDom .qr-type .type-time {
    border-left: 1px dashed #000;
    font-size: 12px;
    line-height: 15px;
    padding-left: 5px;
    padding-right: 10px;
    padding-top:2px;
    overflow:hidden;
  }
  .pdfDom .qr-type .type-time .print-time{
    line-height: 14px;
    float:left;
  }
  .pdfDom .qr-type .type-time .print-timet{
    line-height: 14px;
    float:left;
  }
  .pdfDom .qr-type .slt-state{
    float: left;
    border-left: 1px dashed #000;
    overflow:hidden;
  }
  
  .pdfDom .qr-type2{height: 30px; }
  .pdfDom .qr-type .slt-state-code{
    width: 135px;
    text-align: center;
    overflow: hidden;
    line-height: 28px;
    float:left;
  }
  .pdfDom .qr-type .centre {
    border: 2px solid #333;
    display: inline-block;
    font-size: 12px;
    line-height: 16px;
    width: 16px;
    height: 16px;
  }
  .pdfDom .qr-code {
    border-top: 1px dashed #000;
  }
  
  .pdfDom .qr-code .qr-img {
    width: 50px;
    height: 50px;
    margin-top:3px;
    margin-left:10px;
    float:left;
  }
  .sl-bottom{ 
    width:100%;
    height:10px;
    background:#333;
  }
  .pdfDom .good-msg {
    height: 32px;
  //   border-bottom:1px dashed #000;
  }
  .pdfDom .good-msg .good-msg-left{
    height: 26px;
    width: 40px;
    padding-top:6px;
    border-top:1px dashed #000;
    float: left;
    border-right: 1px dashed #000;
  }
  .bao {
    display:${options.insured ? 'block' : 'none'};
    height: 20px;
    width: 20px;
    margin-left:10px;
  }
  .pdfDom .good-msg .good-msg-right{
    float: left;
  }
  .good-msg-right ul{
      overflow: hidden;
      list-style: none;
      margin: 0;
      font-size: 10px;
      padding-left: 0;
      font-weight:bold
    }
  .good-msg-right ul.top-one{
    border-bottom:1px dashed #000;
  }
  .good-msg-right li{
    float: left;
    width: 60px;
    text-align: center;
    height: 16px;
    line-height: 16px;
    border-right: 1px dashed #000;
  }
  .scd-address {
    width: 100%;
    box-sizing: border-box;
    position:relative;
  }
  .scd-address .scdw-list {
    height: 60px;
    color: #333;
    overflow:hidden;
  }
  .scd-address .scdw-list .slt-state {
    width: 40px;
    height: 100%;
    border-right: 1px dashed #000;
    padding-top:8px;
    float:left;
  }
  .scd-address .scdw-shou .slt-state{
    padding-top: 10px;
    border-bottom: 1px dashed #000;
  }
  .scd-address .scdw-list .slt-state img {
    width: 18px;
    height: 18px;
    margin-left:12px;
  }
  .scd-address .scdw-list .privacy{
    font-weight: bold;
    box-sizing: border-box;
    padding: 2px;
    font-size: 10px;
    width: 225px;
    background: #000;
    color: #fff;
    display:${options.isPrivacy === 1 ? 'block' : 'none'};
}
.scd-address .scdw-list .privacy .number{
    font-size: 12px;
}
  .scd-address .scdw-list .slt-state .shou-img{
    width: 30px;
    height: 30px;
    margin-left:7px;
  }
  .scd-address .scdw-list .sl-top {
    width:179px;
    height:100%;
    border-bottom: 1px dashed #000;
    padding-left: 3px;
    padding-top: 3px;
    font-size: 12px;
    border-right: 1px dashed #000;
    float:left;
    overflow:hidden
  }
  .scd-address .scdw-list .sl-top .slt-info {
    overflow:hidden;
    height:16px;
    line-height:16px;
    width:100%
  }
  .scd-address .scdw-list .sl-top .slt-info .slti-name {
    padding-left:3px
    padding-right: 5px;
    display:block;
    width:70px;
    float:left;
  }
  .scd-address .scdw-list .sl-top .slt-info .slti-n{
    padding-right: 0px;
  }
  .scd-address .scdw-list .sl-top .slt-info .slti-num {
    padding: 0;
    display:block;
    width:102px;
    float:left;
  }
  .scd-address .scdw-shou {
    height: 78px;
    overflow:hidden
  }
  .scd-address .scdw-ji{
    height:63px;
  }
  .scd-address .scdw-shou .sl-top {
    font-size: 11px;
    font-weight:bold;
  }
  .scd-address .scdw-ji .sl-top {
    font-size: 10px;
  }
  .scd-address-bg{
    position:absolute;
    height:80px;
    width:180px;
    font-size:60px;
    color: rgb(244,244,244);
    top:90px;
    left:30px;
  }
  .scd-address-bg .code-img{
    
    display:${options.dataUrl ? 'block' : 'none'};
  }
  .f {
    display: inline-block;
    width: 100px;
    height: 70px;
    background: #ccc;
  }
  .remark{
    height: 18mm;
    font-size: 10px;
    padding: 5px 10px;  
    color:#333;
    position: relative;
    border-top: 1px dashed #000;
  }
  .remark .checked-txt{
    border: 1px solid #000;
    padding: 2px;
    font-size: 12px;
    position: absolute;
    right:8px;
    bottom: 3px;
  }
  .fr {
    float: right;
  }
  p{margin: 0;}
    </style>
  </head>
  <body>
    <div class="clearfix" id="demoContainer" >
       <div class="pdfDom">
         <div class="top-bar">
            <div class="top-bar-right">
            ${$lang('代收货款')}
            </div>
            <div class="top-bar-right1">
            ${$lang('到付')}
            </div>
            <div class="top-bar-right2">
            ${$lang('签单返还')}
            </div>
         </div>
         <div class="qr-type">
           <div class="type-code">${options.terminalDispatchCode}</div>
           ${options.isBusiness === 1 ? '' : `<div class="fr type-name">
           <div class="type-namei">
           ${options.expressTypeName}
           </div>           
          </div>`}
         </div>
         <div class="qr-type qr-type2">
          <div class="slt-state">
            <div class="slt-state-code">
              ${options.lastCenterName ? `<span class="centre">${$lang('集')}</span> ${options.lastCenterName}` : ''}
            <!-- 集 -->
            </div>
          </div>
          <div class="fr type-time" >
             <div class="print-timet">${$lang('打印时间')}:</div>
             <div class=""> 
               <div>${dayObj.day}</div>
               <div>${dayObj.hour}  ${index}/${length}</div>
             </div>
           </div>
         </div>
         <div class="scd-address">
         <div class="scd-address-bg">
           <img class="code-img" src="${options.dataUrl}">
         </div>
           <div class="scdw-list scdw-shou" style="overflow:hidden">
           <div class="privacy" >${$lang('隐私保护 联系收件人')}: <span class="number">${options.secrecyNo}</span></div>
             <div class="slt-state">
               <img class="shou-img" src="${img[0].href}" alt="">
             </div>
             <div class="sl-top"> 
               <div class="slt-info">
                 <span class="slti-name" style="overflow:hidden;margin-right:4px">${options.receiverName}</span>
                 <span class="slti-num">${options.receiverMobilePhone || options.receiverTelphone}</span>
               </div>
               <div style="width:46mm;line-height:14px;height:40px;overflow:hidden;">${options.receiverProvinceName}${options.receiverCityName}${options.receiverAreaName}${options.receiverDetailedAddress}</div>
              </div>
           </div>
           <div class="scdw-list scdw-ji">
             <div class="slt-state">
               <img src="${img[1].href}" alt="">
             </div>
             <div class="sl-top">
               <div class="slt-info">
                <span class="slti-name" style="overflow:hidden;margin-right:4px">${options.senderName}</span>
                <span class="slti-num" style="overflow:hidden">${options.senderMobilePhone || options.senderTelphone}</span>
               </div>
              <div style="overflow:hidden;width:46mm;height:30px;line-height:14px;">${options.senderProvinceName}${options.senderCityName}${options.senderAreaName}${options.senderDetailedAddress}</div>
              </div>
           </div>
         </div>
         <div class="good-msg">
          <div class="good-msg-left">
            <img class="bao" src="${img[3].href}" alt="">
          </div>
          <div class="good-msg-right">
            <ul class="top-one">
            <li>${$lang('代收货款')}</li>
            <li>${$lang('到付运费')}</li>
            <li class="last">${$lang('寄件重量')}</li>
            </ul>
            <ul>
              <li>${options.codMoneyTag}</li>
              <li>${options.totalFreight ? options.currencySymbol + options.totalFreight : ''}</li>
              <li class="last">${options.packageChargeWeight ? options.packageChargeWeight + 'KG' : ''}</li>
            </ul>
          </div>
         </div>
         <div class="bottom-bar">
         </div>
         <div class="remark" style="overflow:hidden;line-height:14px;">
         ${$lang('备注')} ：${options.remarks}
            <div class="checked-txt">${$lang('已检视')}</div>
          </div>
         <div class="qr-code">
          <!-- <img class="qr-img" src="${img[2].href}" alt="">  -->       
         </div>
       </div>
     </div>
   </body>
  </html>`
}

